import React from 'react';
import styled from 'styled-components';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  deleteFlashMessage as deleteFlashMessageAction
} from '../../redux/middleware/flashMessage';

import {
  getFlashMessages
} from '../../redux/reducers/flashMessage';

const Alert = ({ children, ...props }) => (
  <CSSTransition
    {...props}
    timeout={1000}
    classNames="alerts"
  >
    {children}
  </CSSTransition>
);

const StyledAlert = styled(Alert)`
  .alerts-leave {
    opacity: 1;
    padding-bottom: 15px;
    padding-top: 15px;
    margin-bottom: 20px;
    height: 50px;
  }
  .alerts-leave.alerts-leave-active {
    overflow: hidden;
    opacity: 0.01;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    height: 0px;
    transition: opacity 300ms ease-in,
                padding-top 500ms ease-in,
                padding-bottom 500ms ease-in,
                margin-bottom 500ms ease-in,
                height 500ms ease-in;
  }
`

const Container = styled.div`
`

const Button = styled.button`
  float: right;
  border: none;
  background: transparent;
  outline: 0;
`

class FlashMessage extends React.Component {
  render() {
    const {message, handleRemove} = this.props;
    return (
      <StyledAlert className={`alert alert-${message.type}`}>
        <div>
          {message.text}
          <Button onClick={() => handleRemove(message.id)}>
            &times;
          </Button>
        </div>
      </StyledAlert>
    )
  }
}

class Flash extends React.Component {
  
  handleRemove = (id) => {
    this.props.deleteFlashMessage(id)
  }

  render() {
    return (
      <Container>
        <TransitionGroup className='alerts'>
          {this.props.messages.map(message =>
            <FlashMessage
              key={message.id}
              message={message}
              handleRemove={this.handleRemove}
            />
          )}
        </TransitionGroup>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  messages: getFlashMessages(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({
  deleteFlashMessage: deleteFlashMessageAction
}, dispatch)

export default connect( mapStateToProps, mapDispatchToProps )(Flash)
